import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function EnviosDeContadoSinFactura() {
  return (
    <ClipperPlaceholder title="Envíos de Contado Sin Factura" category="Operativas" />
  );
}
